import styled, { css } from 'styled-components'

export const _Hero = styled.div`
  text-align: center;
`

export const _Title = styled.h1`
  margin-bottom: 20px;
  color: white;
  opacity: 1;
  font-size: 72px;
  @media screen and (max-width: 63.9em) {
    font-size: 48px;
  }
  @media screen and (max-width: 47.9em) {
    font-size: 38px;
  }

`

export const subtitleCss = css`
  > div {
    font-size: 18px;
    width: 100%;
    color: white !important;
    opacity: 1;
    text-align: center;
  }
  @media screen and (max-width: 47.9em) {
    > div {
      font-size: 18px;
    }
  }
`
